export const userProfile = {
	profile: 'Profile'
}
